import { menuList, childList } from "@/lib/menuList";

/**
 * 使用meta.role确定当前用户是否具有权限
 * @param roles 权限数组
 * @param route
 */
function hasPermission(roles, route) {
  if (route.meta && route.meta.roles) {
    return roles.some(role => route.meta.id.includes(role))
  } else {
    return true
  }
}

/**
 * 递归过滤异步路由表
 * @param routes asyncRoutes
 * @param roles
 */
export function filterAsyncRoutes(routes, roles) {
  const res = []

  routes.forEach(route => {
    const tmp = { ...route }
    if (hasPermission(roles, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, roles)
      }
      res.push(tmp)
    }
  })

  return res
}

/**
 * 将后端的permissionList转为permissions
 * @param permissionList
 */
export function permissionListToPermissions(permissionList) {
  if (!permissionList || permissionList.length === 0) {
    return permissionList
  }
  //菜单权限
  const menuPermissionList = permissionList.filter(item => {
    return item.displayType === 'MENU'
  })
  //按钮权限
  const actionPermissionList = permissionList.filter(item => {
    return item.displayType !== 'MENU'
  })
  const actionPermissionListMap = {}
  //获取父级菜单下的按钮列表
  actionPermissionList.forEach(item => {
    let actionList = actionPermissionListMap[item.parentId]
    //首次获取赋空数组
    if (actionList === undefined) {
      actionList = []
      actionPermissionListMap[item.parentId] = actionList
    }
    //存在直接push
    actionList.push(item)
  })
  // console.log(actionPermissionList,actionPermissionListMap,"actionPermissionListMap-");
  const permissions = []
  menuPermissionList.forEach(item => {
    // 获取actionList
    let actionEntitySet = actionPermissionListMap[item.id]
    if (actionEntitySet !== undefined) {
      actionEntitySet = actionEntitySet.map(action => {
        return {
          action: action.frontendCode,
          describe: action.displayName,
          defaultCheck: false
        }
      })
    } else {
      actionEntitySet = []
    }
    const actionList = actionEntitySet.map(item => {
      return item.action
    })

    permissions.push({
      id: item.id,
      permissionId: item.frontendCode,
      permissionName: item.displayName,
      actionEntitySet,
      actionList
    })
  })
  return permissions
}
export function getMenuList(list) {
  //获取一级菜单，
  let oneList = list
    .filter((x) => x.displayType == "MENU")
    .filter((y) => y.parentId == 0);
  //给没孩子节点的一级菜单赋path，有二级菜单时会重新赋值
  oneList.forEach(item => {
    let t = menuList.find(x => x.id == item.id);
    if (t) {
      if (t.path) item.path = t.path;
      if (t.icon) item.icon = t.icon
    }
  });
  //获取二级菜单
  let twoList = list
    .filter((x) => x.displayType == "MENU")
    .filter((y) => y.parentId != 0);
  twoList.forEach((item) => {
    let t = childList.find((x) => x.id == item.id);
    if (t) {
      item.path = t.path;
    }
  });
  //
  oneList.forEach((item) => {
    let sublist = twoList.filter((x) => x.parentId == item.id);
    if (sublist.length) {
      item.child = sublist;
      let pathList = sublist.map(x => x.path);
      item.path = pathList[0]
    }
  });
  return oneList;
}